import { Component } from "@angular/core";

@Component({
    selector: "wk-icon-active-member-sprite-pds3",
    templateUrl: "./wk-icon-active-member-sprite-pds3.html",
    host: { class: "cg3-host-wk-icon-active-member-sprite" },
})
export class WkIconActiveMemberSpritePds3 {}
